export function getApiData(type, userData) {
  let BaseURL = 'https://winmigrationgroup.com/master-panel/';
  let headers = new Headers();
  return new Promise((resolve, reject) => {
    headers.append('content-type', 'application/json');

    fetch(BaseURL + type, {
      method: 'POST',
      //headers: headers,
      body: JSON.stringify(userData),
    })
      .then((response) => {
        if (!response.ok) {
          return Promise.reject('Failed to fetch API data');
        }
        return response.json();
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        reject(error);
      });
  });
}
